
    export default 
    {
    "banner_v2": {
        "title": "<span class={title}>Consigue <span class={highlight}>$100</span> y más durante la Temporada de Recompensas Dsers</span>",
        "desc": "La temporada de recompensas Dsers se celebrará del 15 de octubre al 15 de enero.<br /> Las invitaciones se enviarán a los comerciantes al azar en septiembre.<br /> Por favor, verifica el buzón del correo electrónico que utilizaste para crear tu cuenta Dsers.",
        "learn_more": "Más información"
    }
}